import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageServicios} from '../../components/Servicios/PageServicios'
import axios from 'axios'
import {Modal} from 'react-bootstrap'
import {ServiciosBanner} from '../../components/Servicios/ServiciosBanner'

function Servicios() {
  const url = 'https://puntosurgdl.com/backend/'

  const [servicios, setServicios] = useState('')
  const [showNewServicio, setShowNewServicio] = useState(false)

  const handleCloseNewServicio = () => setShowNewServicio(false)
  const handleShowNewServicio = () => setShowNewServicio(true)

  const [showDeleteServicio, setShowDeleteServicio] = useState(false)
  const [servicioElement, setServicioElement] = useState('')

  const handleCloseDeleteServicio = () => setShowDeleteServicio(false)
  const handleShowDeleteServicio = (servicio) => {
    setShowDeleteServicio(true)
    console.log(servicio)
    setServicioElement(servicio)
  }
  useEffect(() => {
    getPageServicios()
  }, [])

  const getPageServicios = () => {
    axios
      .get(url + 'getPageServicios.php')
      .then((response) => {
        console.log(response.data.data)
        let servicios = response.data.data
        setServicios(response.data.data)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const uploadNewServicio = () => {
    const data = new FormData()

    data.append('id', '')
    data.append('name', '')
    data.append('title', document.getElementById('new-servicio-title').value)
    data.append('description', document.getElementById('new-servicio-description').value)

    if (document.getElementById('new-servicio-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-servicio-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-servicio-img').files[i])
      }
      data.append('logoExists', true)
    }

    if (document.getElementById('new-servicio-icono').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-servicio-icono').files.length; i++) {
        data.append('file[]', document.getElementById('new-servicio-icono').files[i])
      }
      data.append('fondoExists', true)
    }

    axios
      .post(url + 'uploadNewServicio.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data.data)
          setServicios(res.data.data)
          handleCloseNewServicio()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const deleteServicio = () => {
    // if (!inputFile) {
    //   alert('Seleccione un archivo')
    //   return false
    // }

    let url = 'https://puntosurgdl.com/backend/'

    const data = {
      name: servicioElement.idElement,
    }

    axios
      .post(url + 'deleteServicio.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          console.log(res)
          // then print response status
          setServicios(res.data.data)
          handleCloseDeleteServicio()
        },
        (error) => {
          alert(error)
        }
      )
  }

  return (
    <div className='row g-5'>
      <ServiciosBanner />

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5 video-banner'>
          <div className='card-header'>
            <h3 className='card-title'>Servicios</h3>
            <h5 className='card-subtitle'>
              La imagen debe tener un formato vertical, con una medida mínima de 400px por 500px y
              no pesar más de 1MB
            </h5>
            <h5 className='card-subtitle'>El icono debe ser blanco en formato png</h5>

            <div className='form-group float-end'>
              <button
                type='submit'
                className='btn btn-primary mt-n20 mb-10'
                onClick={handleShowNewServicio}
              >
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <PageServicios servicios={servicios} deleteServicio={handleShowDeleteServicio} />
            </div>
          </div>
          {/* <div className='card-footer'>
            <div className='form-group float-end'>
              <button type='submit' className='btn btn-primary mt-6'>
                Guardar
              </button>
            </div>
          </div> */}
        </div>
      </div>

      <Modal show={showNewServicio} onHide={handleCloseNewServicio} className='modal-new-event'>
        <Modal.Header closeButton>
          <Modal.Title>Agregar servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Titulo:</label>
              <input type='text' className='form-control' id='new-servicio-title' />
            </div>
            <div className='form-group col-md-10'>
              <label>Descripcion:</label>
              <input type='text' className='form-control' id='new-servicio-description' />
            </div>
            <div className='form-group col-md-10'>
              <label>Imagen de fondo:</label>
              <input id='new-servicio-img' type='file' className='form-control' accept='image/*' />
            </div>
            <div className='form-group col-md-10'>
              <label>Icono:</label>
              <input id='new-servicio-icono' type='file' className='form-control' accept='.png' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewServicio}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={() => uploadNewServicio()}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteServicio}
        onHide={handleCloseDeleteServicio}
        className='modal-delete-servicio'
      >
        <Modal.Header closeButton>
          <Modal.Title>Eliminar servicio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Seguro que desea eliminar servicio?</p>
          <p>Esta acción no puede deshacerse</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteServicio}>
            Cerrar
          </button>
          <button type='button' className='btn btn-danger' onClick={() => deleteServicio()}>
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export {Servicios}
